import { ReactNode, useEffect } from 'react'
import { FormProvider as Form, UseFormReturn } from 'react-hook-form'

// --------------------------------------------------------------------------------------------- //

interface FormProviderProps {
  children?: ReactNode
  methods: UseFormReturn<any>
  onSubmit?: VoidFunction
  defaultValues?: any
}

export function FormProvider({ children, onSubmit, methods, defaultValues }: FormProviderProps) {
  useEffect(() => {
    if (defaultValues) {
      methods?.reset(defaultValues)
    }
  }, [defaultValues])

  if (onSubmit) {
    return (
      <Form {...methods}>
        <form onSubmit={onSubmit}>{children}</form>
      </Form>
    )
  }

  return <Form {...methods}>{children}</Form>
}
